import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './Profile.module.css';
import { getPostsFromFirestore } from '../../firebase/postService';
import PostCard from '../../Components/PostCard/PostCard';

const Profile = () => {
  const user = useSelector(state => state.auth.user);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      const allPosts = await getPostsFromFirestore();
      setPosts(allPosts.filter(p => p.uid === user.uid));
      setLoading(false);
    })();
  }, [user]);

  if (!user) {
    return <div className={styles.container}>ログインしてください</div>;
  }

  return (
    <div className={styles.container}>
      <h2>プロフィール</h2>
      <div className={styles.profileInfo}>
  <div><strong>表示名:</strong> {user.displayName || '未設定'}</div>
        {user.photoURL && (
          <div style={{marginTop:16}}>
            <img src={user.photoURL} alt="プロフィール画像" style={{width:96, height:96, borderRadius:'50%', border:'1px solid #ccc'}} />
          </div>
        )}
      </div>
      <div style={{marginTop:32, textAlign:'left'}}>
        <h3 style={{marginBottom:12}}>自分の投稿一覧</h3>
        {loading ? (
          <div>読み込み中...</div>
        ) : posts.length === 0 ? (
          <div>まだ投稿がありません。</div>
        ) : (
          <ul style={{padding:0, listStyle:'none'}}>
            {posts.map(post => (
              <li key={post.id} style={{marginBottom:20, listStyle:'none'}}>
                <PostCard post={post} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Profile;
